module.exports = __webpack_public_path__ + "static/media/highlighted_yellow.aa1b27ee.svg";